// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__oOH-9","dark":"style_dark__PAB-I","light":"style_light__9zVDH"};